import * as Toggle from '@radix-ui/react-toggle-group'
import { useKestrel } from 'features/kestrelViewer'
import React, { FC, useState } from 'react'
import styled from 'styled-components'
import { Vector2 } from 'three'
import { KVPlaneIntersection } from 'types'

import { DeletePlaneIntersectionButton } from './DeletePlaneIntersectionButton'
import { DownloadPlaneIntersectionStepFile } from './DownloadPlaneIntersectionStepFile'
import { TogglePlaneIntersectionVisibilityButton } from './TogglePlaneIntersectionVisibilityButton'

const StyledPlaneIntersectionEntry = styled(Toggle.Item)<{
  $selected: boolean
}>`
  all: unset;
  cursor: ${({ $selected }) => ($selected ? 'auto' : 'pointer')} !important;
  background-color: ${({ theme, $selected }) =>
    $selected ? theme.forecast.background4 : ''} !important;
  position: relative;
  padding: 0.25rem;

  &:hover {
    opacity: ${({ $selected }) => ($selected ? 0.8 : 1)} !important;
    background-color: ${({ theme, $selected }) =>
      $selected
        ? theme.forecast.background4
        : theme.forecast.background3} !important;
  }
`

const PrimaryLineContainer = styled.div<{ $visible: boolean }>`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  align-items: center;
  color: ${({ $visible }) => ($visible ? 'white' : 'gray')};
  overflow: hidden;
`

const LeftSideInfo = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  max-width: calc(100% - 80px);
  overflow: hidden;
`

const PlaneIntersectionLabel = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`

const ActionsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  position: absolute;
  right: 0;
`

export const PlaneIntersectionEntry: FC<{
  planeIntersection: KVPlaneIntersection
  selectedMarkupId: string | undefined
}> = ({ planeIntersection, selectedMarkupId }) => {
  const isSelected = planeIntersection.id === selectedMarkupId
  const [isHovered, setIsHovered] = useState(false)
  const { setPopupMenuStartPosition, setSelectedMarkup } = useKestrel()

  return (
    <StyledPlaneIntersectionEntry
      value={planeIntersection.id}
      $selected={isSelected}
      onClick={() => {
        if (setPopupMenuStartPosition) {
          setPopupMenuStartPosition(new Vector2(80, 20))
        }
        setSelectedMarkup(
          selectedMarkupId === planeIntersection.id
            ? undefined
            : planeIntersection
        )
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      <PrimaryLineContainer
        $visible={planeIntersection.planeIntersectionVisible}>
        <LeftSideInfo>
          <PlaneIntersectionLabel>
            {planeIntersection.planeIntersectionLabel}
          </PlaneIntersectionLabel>
        </LeftSideInfo>
        {isHovered && (
          <ActionsContainer>
            <DownloadPlaneIntersectionStepFile
              planeIntersection={planeIntersection}
            />
            <TogglePlaneIntersectionVisibilityButton
              planeIntersection={planeIntersection}
            />
            <DeletePlaneIntersectionButton
              planeIntersectionId={planeIntersection.id}
            />
          </ActionsContainer>
        )}
      </PrimaryLineContainer>
    </StyledPlaneIntersectionEntry>
  )
}
